import { lazy, Suspense } from 'react'

const ConnectedContentWorkflowComponent = lazy(() => import('.'))

export const ConnectedContentWorkflow: React.VFC = (props) => (
  <Suspense fallback={null}>
    <ConnectedContentWorkflowComponent {...props} />
  </Suspense>
)
